export default "__VITE_PUBLIC_ASSET__cca752f5__"